import * as React from 'react';
import { SVGProps } from 'react';

export const GenericDocSVG = (props: SVGProps<SVGSVGElement> & { text: string }) => (
    <svg
        width="100%"
        height="auto"
        viewBox="0 0 40 40"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3 6a4 4 0 0 1 4-4h20l10 10v22a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V6Z"
            fill="#e2e8f0"
            stroke="#64748b"
            strokeWidth={2}
            strokeLinejoin="round"
        />
        <path d="M27 10V2l10 10h-8a2 2 0 0 1-2-2Z" fill="#fff" />
        <path
            d="m27 2 .707-.707A1 1 0 0 0 26 2h1Zm10 10v1a1 1 0 0 0 .707-1.707L37 12ZM26 2v8h2V2h-2Zm3 11h8v-2h-8v2Zm8.707-1.707-10-10-1.414 1.414 10 10 1.414-1.414ZM26 10a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1h-2Z"
            fill="#64748b"
        />
        <text
            id="text"
            x="50%"
            y="55%"
            fill="#64748b"
            style={{ fontSize: props?.text?.length === 3 ? '16px' : '14px' }}
            textAnchor="middle"
            dominantBaseline={'middle'}
        >
            {props.text}
        </text>
    </svg>
);
